import { Component, ViewChild, ElementRef, OnDestroy } from '@angular/core';

import { AuthServiceGuest } from './../../services/AuthServiceGuest';
import { GuestsService } from './../../services/GuestsService';

import { Guest } from './../../dataTypes/Guest';
import { Site } from './../../dataTypes/Site';

import { CurrentUser } from './../../dataTypes/CurrentUser';

import { LanguageService } from './../../services/LanguageService';
import { LanguageConstants } from './../../common/language/LanguageConstants';
import * as _ from 'lodash';
import { MatDialog, MatDialogRef } from '@angular/material';
import { EditGuestDialog } from './saveGuest/editGuest.dialog';
import { MessageToUserDialog } from '../../shared/dialog/messageToUser.dialog';
import { Park } from '../../dataTypes/Park';
import { ParkForReservedSubscriber } from '../../dataTypes/ParkForReservedSubscriber';
import { ImportGuestsDialog } from './importGuests/importGuests.dialog';
import { AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import { MobileStatusService } from '../../services/MobileStatusService';
import { HostListener } from '@angular/core';
import { environment } from '../../../environments/environment.prod';

import * as moment from 'moment';


@Component({
  selector: 'guests',
  templateUrl: './Guests.html',
  styleUrls: ['./Guests.css']
})

export class Guests implements AfterViewInit, OnDestroy  {

  public language = 'en';
  public languageConstants = LanguageConstants['en'];
  public rtl = false;

  public _isMobile: boolean = false;

  displayedColumns: string[] = [];

  public entranceDate: any;
  public exitDate: any;

  public _guestsList: Guest[] = [];
  public _selectedGuest: Guest;

  public sites: Site[] = [];
  public _searchByLPRNumber: string;
  public _searchByName: string;
  public _filterInSiteOnly: boolean;

  public _isAtidim: boolean;


  public counting = {
    "reservedPlaces": 0,
    "freePlaces": 0,
    "guestsCount": 0,
    "subscribersCount": 0,
    "constSubscribersCount": 0
  };

  public _errorFromServer: string;

  public user: CurrentUser;

  public _parksList: Park[];
  public _selectedPark: number;
  public _parkForReservedSubscriberList: ParkForReservedSubscriber[];

  //----------
  public _screenSize: { width: number; height: number } = {
    width: 0,
    height: 0
  };

  private dialogRef: MatDialogRef<EditGuestDialog> | undefined;

  public _showEditGuestDialog: boolean = false; 

  @ViewChild('guestsTable', { static: true }) guestsTable!: ElementRef;


  _EditGuestDialogModel: EditGuestModel;

  public _selectedAction: GuestsAction = GuestsAction.None;

  useMobileByForce: boolean = environment.useMobileOnly;

  private _isRealyMobileDevice: boolean = false;

  //---------- transferred from editGuest.dialog.ts variables --------------
  public _startDate: Date;
  public _endDate: Date;
  public startTime: string = "00:00";
  public endTime: string = "00:00";
  public _errorString: string;

  public _isVertical: boolean = false; // Add the isVertical flag Horizontal
 
  public _selectedDestinedPark: number;
  public parksForDestinedGuest: ParkForReservedSubscriber[];
  public _screenWidth: number;
  //------------------------------------------------------------------------

  public garbageVisible: boolean = false;

  constructor(public _language: LanguageService,
    public _GuestsService: GuestsService,
    public _AuthService: AuthServiceGuest,
    public _dialog: MatDialog,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private mobileStatusService: MobileStatusService  ) {

    this._language.language$.subscribe(
      language => {
        this.language = language;
        this.languageConstants = LanguageConstants[this.language];
      });
    this._language.rtl$.subscribe(
      rtl => {
        this.rtl = rtl;
      });

    //---------------
    
    this._EditGuestDialogModel = {
      guest: new Guest(
    /* guestId: */ null,
    /* identityNumber: */ null,
    /* companyID: */ null,
    /* userId: */ null,
    /* firstName: */ '',
    /* lastName: */ '',
    /* carNo: */ '',
    /* entranceDate: */ null,
    /* exitDate: */ null,
    /* sitesList: */[],
    /* inside: */ null,
    /* parkDescription: */ null,
    /* parkEntranceDate: */ null,
    /* parkNumber: */ null,
    /* destinedPark: */ null
      ),
      isEdit: false,
      guestValidateIdentityNumber: false,
      AllowEditGuestEndDate: false,
      incrementEndDateByOneDay: false,
      isAtidim: false,
      parksForDestinedGuest: []
    };
    //---------------
  }

  ngOnInit(): void {
    
    this.updateOrientation();
    window.addEventListener('resize', this.updateOrientation.bind(this));

    const self = this;

    self._isAtidim = true;

    self.user = self._AuthService.getUserInfo();
    //רמת הרשאה 0.עדכון\הוספה\מחיקה 1.עיון בלבד
    if (self.user.permission === 1) {
      this.displayedColumns = [
        'identityNumber', 'firstName', 'lastName', 'carNumber', 'startDate', 'finishDate', 'isInSite', 'parkDescription', 'EntranceDate'];
    }

    self._GuestsService.selectedCompanySubject.subscribe(
      data => {
        if (data) {
          self.getCounting();
          self.parks();
          self.getParksForReservedSubscriber();
          self.getGuestsList('');
          self.getOverflowLevels();
        }

      }
    );

    if (self._GuestsService._selectedCompany) {
      self.getCounting();
      self.parks();
      self.getParksForReservedSubscriber();
      self.getGuestsList('');
      self.getOverflowLevels();
    }
  }

  updateOrientation() {
    this._isVertical = window.matchMedia('(orientation: portrait)').matches;
  }


  _isOdd(index: number): boolean {
    return index % 2 !== 0;
  }
  //----------------------------

  ngAfterViewInit(): void {

    //+++++++++++++++
    this._isRealyMobileDevice = this.isRealyMobileDevice();
    console.log('Guests _isRealyMobileDevice ' + this._isRealyMobileDevice);
    //+++++++++++++++

    this._isMobile = this.isMobileDevice();
    //console.log('Guests ngAfterViewInit ' + this._isVertical);

    //this._isMobile = (this.useMobileByForce === false) ? window.matchMedia('(max-width: 767px)').matches : true;
    //this._isMobile = window.matchMedia('(max-width: 767px)').matches;
    //this._isMobile = true; // true ->> for similate on PC the Mobile version
    //console.log('Guests ngAfterViewInit ' + this._isMobile ? 'Mobile' : 'Desktop');

    /*    console.log('Guests user.permission ' +  this.user.permission);*/

    console.log('Guests ngAfterViewInit Vertical: %s %s', this._isVertical, this._isMobile ? 'Mobile' : 'Desktop');

    this.displayedColumns = [];

    this.displayedColumns = (this.user.permission === 1) ? ['identityNumber', 'firstName', 'lastName', 'carNumber', 'startDate', 'finishDate', 'isInSite', 'parkDescription', 'EntranceDate']
      : ['identityNumber', 'firstName', 'lastName', 'carNumber', 'startDate', 'finishDate', 'isInSite', 'parkDescription', 'EntranceDate', 'editGuestAction', 'deleteGuestAction'];

    //-----------transferred from editGuest.dialog.ts---------
    if (this._isMobile) {
      this.displayedColumns = ['fullName', 'divider1', 'carNumber', 'divider2', 'finishDate'];
      if (this._EditGuestDialogModel.isAtidim === true && this._EditGuestDialogModel.parksForDestinedGuest.length > 0) {
        this._selectedDestinedPark = this._EditGuestDialogModel.parksForDestinedGuest[0].id;
        this.parksForDestinedGuest = this._EditGuestDialogModel.parksForDestinedGuest;
      }

      if (this._EditGuestDialogModel.isEdit === false) {// new
        this._startDate = new Date();
        this._endDate = new Date();
        this._endDate.setDate(this._startDate.getDate() + 1); // add one day to today
      }
      else { // edit
        this._startDate = new Date(this._EditGuestDialogModel.guest.entranceDate);
        this.startTime = this._EditGuestDialogModel.guest.entranceDate.substring(11, 16);
        this._endDate = new Date(this._EditGuestDialogModel.guest.exitDate);
        this.endTime = this._EditGuestDialogModel.guest.exitDate.substring(11, 16);



        if (this._EditGuestDialogModel.isAtidim === true && this._EditGuestDialogModel.guest.destinedPark) {
          this._selectedDestinedPark = this._EditGuestDialogModel.parksForDestinedGuest.find(x => x.id === this._EditGuestDialogModel.guest.destinedPark).id;

          if (!this._selectedDestinedPark) {

            this._selectedDestinedPark = this._EditGuestDialogModel.parksForDestinedGuest[0].id;

          }
        }
      }
    }


    //-----------transferred from editGuest.dialog.ts---------

    setTimeout(() => {
      this._isMobile = this.isMobileDevice();
      /////this._isMobile = (this.useMobileByForce === false) ? window.matchMedia('(max-width: 767px)').matches : true;
      /////this._isMobile = window.matchMedia('(max-width: 767px)').matches;
      /////this._isMobile = true;
      this.mobileStatusService.setMobileStatus(this._isMobile);
    }, 0);

    this.updateScreenWidth();

    this.cdr.detectChanges();
  }


  //--------------
  getScreenSize() {
    this._screenSize = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }



  isMobileDevice(): boolean {

    this.getScreenSize();
    //console.log('Guests isMobileDevice ScreenSize width ' + this._screenSize.width);

    return this._isRealyMobileDevice ? true
      : this.useMobileByForce === false ? this._screenSize.width < this._screenSize.height
      : true;
  }
  //--------------


  //+++++++++++++++++++++++++++++
  private isRealyMobileDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      /android|webos|iphone|ipad|ipod|blackberry|windows phone/i.test(userAgent)
    );
  }
  //+++++++++++++++++++++++++++++



  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any): void {
    this.updateScreenWidth();
    if (!this._isRealyMobileDevice) {
      console.log('Guests.ts onWindowResize reload ' + this._isRealyMobileDevice);
      location.reload();
    }
  }

  private updateScreenWidth(): void {
    //this._screenWidth = window.innerWidth > 767 ? window.innerWidth + 15 : window.innerWidth ;
    this._screenWidth = window.innerWidth +15;
  }


  ngOnDestroy() {
    console.log('Guests ngOnDestroy ');
    if (this._isMobile) {
      document.removeEventListener('click', this.onOutsideClick.bind(this));
    }
  }

  /*reloadApp(): void {
    //window.location.reload();
  }*/


  getUserPermissionStyles(): any {

    const styles = {
      'text-align': 'center'
    };

    //styles['background-color'] = 'red';

    if (this.user.permission !== 0) {
  
      styles['transform'] = 'scale(1.75)';

      if (this._isMobile) {
        styles['padding-top'] = '15px';
        styles['padding-right'] = '15px';
      }
      else {
        styles['padding-bottom'] = '30px';
        styles['padding-right'] = '60px';
      }
      
      if (this._GuestsService._selectedCompany.id === 1) {
        styles['opacity'] = '0.5';
        styles['pointer-events'] = 'none';
      }

      return styles;
    }
  }


  getForcePadding(): any {
    if (this.user.permission !== 0) {
      return {
        'padding-right': '20px',
      }
    }
  }

  desableWhenNonSelectedCompany() {
    const styles = {
    
    };

    if (this._GuestsService._selectedCompany.id === 1) {
      styles['opacity'] = '0.5';
      styles['pointer-events'] = 'none';
    }

    return styles;
  }


  //-----------------------------


  getParksForReservedSubscriber() {

    const self = this;

    self._GuestsService.getParksForReservedSubscriber()
      .subscribe((data: ParkForReservedSubscriber[]) => {
        if (data) {
          self._parkForReservedSubscriberList = data;
        }
      },
        error => { }
      );
  }


  parks() {

    const self = this;

    self._GuestsService.getParks()
      .subscribe((data: Park[]) => {



        self._parksList = data;
        var t = new Park();
        t.id = -1;
        t.parkDescription = 'כל החניונים';


        var t1 = new Park();
        t1.id = -2;
        t1.parkDescription = 'הצג הכל';

        self._parksList.push(t);
        self._parksList.push(t1);
        self._selectedPark = t1.id;


      },
        error => { }
      );
  }

  getOverflowLevels() {

    const self = this;

    self._GuestsService.getOverflowLevels()
      .subscribe((data: boolean) => {

        if (data === true) {
          self._isAtidim = true;
        }
        else self._isAtidim = false;
      },
        error => { }
      );
  }


  filterInParkOnly1($event) {

    let self = this;

    if (this._selectedPark > 0 || this._selectedPark === -1 || this._selectedPark === -2) {

      self._GuestsService.getGuests('', self.user.Id)
        .subscribe((data: Guest[]) => {

          self._guestsList = data;


          if (this._selectedPark > 0) {
            self._guestsList = self._guestsList.filter(x => x.inside > 0 && x.parkNumber === self._selectedPark).slice(0);
          }
          if (this._selectedPark === -1) {

            self._guestsList = self._guestsList.filter(x => x.inside > 0).slice(0);
          }

          self._selectedGuest = self._guestsList[0];
        },
          error => { }
        );

    }
  }

  filterInSiteOnly() {

    if (this._filterInSiteOnly === true && this._selectedPark > 0) {
      this._guestsList = this._guestsList.filter(x => x.inside > 0 && x.parkNumber === this._selectedPark).slice(0);
    }
    else if (this._filterInSiteOnly === true) {
      this._guestsList = this._guestsList.filter(x => x.inside > 0).slice(0);
    }
    else {
      this.getGuestsList('');
    }
  }


  filterInParkOnly() {

    //if (this._selectedPark && (this._filterInSiteOnly === true)) {

    //  this._guestsList = this._guestsList.filter(x => x.parkNumber === this._selectedPark).slice(0);
    //}
    //else {
    //  this.getGuestsList('');
    //}
  }




  onGuestSelected(guest: Guest) {

    const self = this;

    self._selectedGuest = guest;
  }

  onGuestsUpload() {
    // open dialog
    let self = this;

    const dialogRef = this._dialog.open(ImportGuestsDialog, {
      /////width: '600px', height: '360px', direction: 'rtl', disableClose: true
      //--------
      width: this._isMobile ? '100vw' : '600px',
      height: this._isMobile ? '75vh' : '700px',
      direction: 'rtl', disableClose: true
      //-------------
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      self.getGuestsList('');
    });
  }




  //=================
  onNewGuestClick() {
    if (this._isMobile) {
      //~~~~~~~Refresh ~~~~
        this._EditGuestDialogModel = {
          guest: new Guest(),
          isEdit: false,
          guestValidateIdentityNumber: this.user.guestValidateIdentityNumber,
          AllowEditGuestEndDate: false,
          incrementEndDateByOneDay: false,
          isAtidim: false,
          parksForDestinedGuest: [],
        };
      //~~~~~~~~~~~~~~~~~~~~
      this._showEditGuestDialog = true;
      this._EditGuestDialogModel.AllowEditGuestEndDate = true;

      this._startDate = new Date();
      this._endDate = new Date();
      this._endDate.setDate(this._startDate.getDate() + 1); // add one day to today
      this.startTime = "00:00";
      this.endTime = "00:00";

      this._selectedAction = GuestsAction.addNewGuest;
    }
    else {
      this.dialogRef = this._dialog.open(EditGuestDialog, {
        width: this._isMobile ? '100vw' : '600px',
        height: this._isMobile ? '75vh' : '700px',
        direction: 'rtl',
        data: {
          guest: new Guest(),
          guestValidateIdentityNumber: this.user.guestValidateIdentityNumber,
          AllowEditGuestEndDate: this.user.AllowEditGuestEndDate,
          incrementEndDateByOneDay: this.user.incrementEndDateByOneDay,
          isEdit: false,
          isAtidim: this._isAtidim,
          parksForDestinedGuest: this._parkForReservedSubscriberList
        },
        panelClass: 'custom-dialog-overlay' // Add your custom CSS class for modal dialog here
      });

      this.dialogRef.afterClosed().subscribe((result: Guest) => {
        if (result) {
          this._selectedGuest = result;
          this._selectedGuest.userId = parseInt(this.user.Id);
          this.onNewGuestSave();
        }
      });
    } 
  }


  onOutsideClick(event: Event) {
    console.log('Guests onOutsideClick  ');

    if (!this.guestsTable.nativeElement.contains(event.target)) {
      this._showEditGuestDialog = false;
    }
  }

  //=================

  onNewGuestSave() {

    let self = this;
    self._selectedGuest.companyID = self._GuestsService._selectedCompany.id;

    self._GuestsService.addGuest(self._selectedGuest)
      .subscribe((data) => {



        if (data["error"]) {
          self._errorFromServer = data["errorMessage"];

          /*const dialogRef = this._dialog.open(MessageToUserDialog, {
            width: '600px', height: '200px', direction: 'rtl', data: self._errorFromServer
          });*//////

          //----------------

          const dialogRef = this._dialog.open(MessageToUserDialog, {
            width: this._isMobile ? '100%' : '600px',
            height: this._isMobile ? '75%' : '700px',
            direction: 'rtl', data: { message: self._errorFromServer, isMobile: this._isMobile } //self._errorFromServer
          });

          //------------------------------


        }

        self.getGuestsList('');
      },
        error => { }
      );
  }

  onEditGuestClick(guest: Guest) {

    let self = this;

    self._selectedGuest = guest;

    //----------
    if (this._isMobile) {
      this._showEditGuestDialog = true;
      this._EditGuestDialogModel.guest = self._selectedGuest;
      this._EditGuestDialogModel.guestValidateIdentityNumber = self.user.guestValidateIdentityNumber;
      this._EditGuestDialogModel.AllowEditGuestEndDate = self.user.AllowEditGuestEndDate;
      this._EditGuestDialogModel.incrementEndDateByOneDay = this.user.incrementEndDateByOneDay;
      this._EditGuestDialogModel.isEdit = true;
      this._EditGuestDialogModel.isAtidim = self._isAtidim;
      this._EditGuestDialogModel.parksForDestinedGuest = this._parkForReservedSubscriberList;

      this._startDate = new Date(this._EditGuestDialogModel.guest.entranceDate);   
      this.startTime = this._EditGuestDialogModel.guest.entranceDate.substring(11, 16);

      this._endDate = new Date(this._EditGuestDialogModel.guest.exitDate);
      this.endTime = this._EditGuestDialogModel.guest.exitDate.substring(11, 16);
      

      if (this._EditGuestDialogModel.isAtidim === true && this._EditGuestDialogModel.guest.destinedPark) {
        this._selectedDestinedPark = this._EditGuestDialogModel.parksForDestinedGuest.find(x => x.id === this._EditGuestDialogModel.guest.destinedPark).id;

        if (!this._selectedDestinedPark) {

          this._selectedDestinedPark = this._EditGuestDialogModel.parksForDestinedGuest[0].id;
        }
      }

      this._selectedAction = GuestsAction.editGuest;
    }
    else {
      const dialogRef = this._dialog.open(EditGuestDialog, {
        width: '600px', height: '600px', direction: 'rtl', data: {
          guest: self._selectedGuest,
          guestValidateIdentityNumber: self.user.guestValidateIdentityNumber,
          AllowEditGuestEndDate: self.user.AllowEditGuestEndDate,
          incrementEndDateByOneDay: this.user.incrementEndDateByOneDay,
          isEdit: true,
          isAtidim: self._isAtidim,
          parksForDestinedGuest: this._parkForReservedSubscriberList
        }
      });

      dialogRef.afterClosed().subscribe((result: Guest) => {


        if (result) {
          self._selectedGuest = result;
          self.onEditGuestSave();
        }
      });
    }
    //----------
  }

  onEditGuestSave() {

    let self = this;

    self._GuestsService.editGuest(self._selectedGuest)
      .subscribe((data) => {


        if (data["error"] === true) {
          self._errorFromServer = data["errorMessage"];

          const dialogRef = this._dialog.open(MessageToUserDialog, {
            width: '200', height: '200px', direction: 'rtl', data: { message: self._errorFromServer, isMobile: this._isMobile } // data: self._errorFromServer
          });
        }

        self.getGuestsList('');
      },
        error => { }
      );
  }

  //---------Added by request of Shmulik and Yinon----------------
  onDeleteGuestClick(guest: Guest) {
    let self = this;// Save the value


    const dialogRef = this._dialog.open(MessageToUserDialog, {
      width: this._isMobile ? '400px' :'650px',
      height: '200px',
      direction: 'rtl',
      data: {
        message: this._isMobile ? 'AreUSureDeleteGuestMobile' : 'AreUSureDeleteGuest',
        isMobile: this._isMobile
      }
    });

  
    //const promise = new Promise<boolean>((resolve) => {
      dialogRef.afterClosed().subscribe((result: boolean) => {
        //resolve(result); // Resolve the promise when the dialog is closed
      if (result === true) {
    //    // `_selectedGuest` will be available here
    //    this.performAction(GuestsAction.deleteGuest);

        if (this._isMobile) {
          this._showEditGuestDialog = false;
        }

        this.onDeleteGuestSave();
      }

      //});
    });

    //promise.then((result: boolean) => {
    //  if (result === true) {
    //    // `_selectedGuest` will be available here
    //    this.performAction(GuestsAction.deleteGuest);

    //    if (this._isMobile) {
    //      this._showEditGuestDialog = false;
    //    }

    //    this.onDeleteGuestSave();
    //  }
    //});
  }



  onDeleteGuestSave() {

    const self = this;

    self._GuestsService.deleteGuest(self._selectedGuest.guestId)
      .subscribe((data) => {

        if (data["error"]) {

          self._errorFromServer = data["errorMessage"];

          const dialogRef = this._dialog.open(MessageToUserDialog, {
            width: '600px', height: '300px', direction: 'rtl', data: { message: self._errorFromServer, isMobile: this._isMobile } // data: self._errorFromServer
          });
        }

        self.getCounting();
        self.getGuestsList('');
      },
        error => { }
      );
  }
   //---------Added by request of Shmulik and Yinon----------------

  onSeachClick() {

    this.getGuestsList(this._searchByLPRNumber);
  }

  getGuestsList(searchBy: string) {

    const self = this;

    if (!searchBy) {
      searchBy = '';
    }

    self._GuestsService.getGuests(searchBy, self.user.Id ) //: "Administrator" //Send request with currenet user id
      .subscribe((data: Guest[]) => {

        self._guestsList = data; 
        self._selectedGuest = self._guestsList[0];
      },
        error => { }
      );
  }

  getCounting() {

    const self = this;

    self._GuestsService.getCounting()
      .subscribe((data) => {

        self.counting = data[0];
      },
        error => {
          console.error('GuestsService.getCounting error ' + error);
        }
      );
  }

  isExpired(exitDate: string): boolean {

    let expired: boolean;
    expired = false;

    let datee = new Date(exitDate);
    if (datee < new Date()) {
      expired = true;
    }

    return expired;
  }

  //------transferred functional from editGuest.dialog.ts--------
  onSaveClick(): void {

    const [hs, ms] = this.startTime.split(":");
    let hoursStart = Number.parseInt(hs), minutesStart = Number.parseInt(ms);

    try {
      if (this._startDate instanceof Date) {
        this._startDate.setHours(hoursStart, minutesStart);
        this._startDate.setSeconds(0);
      }
      else {
        console.log('Start date not instanceof Date');
        const dmh = moment(this._startDate);
        dmh.set('hour', hoursStart).set('minute', minutesStart);
        this._startDate = dmh.toDate();
      }

    } catch (e) {
      console.log(e);
    }

    // ---- End Time Section
    const [he, me] = this.endTime.split(":");
    let hoursEnd = Number.parseInt(he), minutesEnd = Number.parseInt(me);
    try {
      console.log(this._endDate.toString());
      if (this._endDate instanceof Date) {
        this._endDate.setHours(hoursEnd, minutesEnd);
        this._endDate.setSeconds(0);
      }
      else {
        console.log('End date not instanceof Date');
        const dmh = moment(this._endDate);
        dmh.set('hour', hoursEnd).set('minute', minutesEnd);
        this._endDate = dmh.toDate();

      }
    } catch (e) {
      console.log(e);
    }
      this._EditGuestDialogModel.guest.entranceDate = this.datePipe.transform(this._startDate, 'yyyy-MM-dd HH:mm');

      // set end date for new guest
      if (this._EditGuestDialogModel.isEdit === false && this._EditGuestDialogModel.AllowEditGuestEndDate === false) {
        this._EditGuestDialogModel.guest.exitDate = '';
      }
      else {
        this._EditGuestDialogModel.guest.exitDate = this.datePipe.transform(this._endDate, 'yyyy-MM-dd HH:mm');
      }

      this._EditGuestDialogModel.guest.destinedPark = this._selectedDestinedPark;


    //++++++++++++++++++
    if (this.InputFieldsAreValid() === true) {
      this._showEditGuestDialog = false;
      this._selectedGuest = this._EditGuestDialogModel.guest;
      this._selectedGuest.userId = parseInt(this.user.Id);
        //this._EditGuestDialogModel.AllowEditGuestEndDate = false; //
      this.performAction(this._selectedAction);
    }
    else {
      // show alert
      console.log('Guest Validation failed');
    }
    //++++++++++++++++++

  }


  //=============================
  onNoClick(): void {
    if (this._isMobile) {
      this._showEditGuestDialog = false;
      this._EditGuestDialogModel.isEdit = false;
    }
    location.reload();
  }
  //===============================


  InputFieldsAreValid(): boolean {

    if (this._EditGuestDialogModel.guestValidateIdentityNumber === true && this._EditGuestDialogModel.isEdit === false) {
      if (!this._EditGuestDialogModel.guest.identityNumber) {
        this._errorString = 'IdentityNumberisarequiredfield', 'error';
        return;
      }
    }

    const identityRe = /^\d+$/;
    if (this._EditGuestDialogModel.guestValidateIdentityNumber && this._EditGuestDialogModel.isEdit === false) {
      if (!identityRe.test(String(this._EditGuestDialogModel.guest.identityNumber))) {
        this._errorString = 'InvalidformatofIdentityNumber';
        return;
      }
    }

    if (!this._EditGuestDialogModel.guest.carNo) {
      this._errorString = 'CarNumbercantbeempty', 'error';
      return;
    }

    const carRe = /^\d+$/;
    if (!carRe.test(this._EditGuestDialogModel.guest.carNo)) {
      this._errorString = 'InvalidformatofCarNumber', 'error';
      return;
    }

    if (!this._EditGuestDialogModel.guest.firstName) {
      this._errorString = 'FirstNameCantbeempty', 'error';
      return;
    }

    if (!this._EditGuestDialogModel.guest.lastName) {
      this._errorString = 'LastNamecantbeempty', 'error';
      return;
    }

    if (!this._EditGuestDialogModel.guest.entranceDate) {
      this._errorString = 'Datecantbeempty', 'error';
      return;
    }

    if (this._endDate < new Date() || this._startDate < new Date(2000, 1, 1)) {

      this._errorString = 'DatesInvalid', 'error';
      return;
    }


    if (!this._EditGuestDialogModel.guest.exitDate && this._EditGuestDialogModel.AllowEditGuestEndDate === true) {
      this._errorString = 'EndDatecantbeempty', 'error';
      return;
    }

    return true;
  }

  //==================
  performAction(action: GuestsAction) {
    if (action === GuestsAction.addNewGuest) {
      this.onNewGuestSave();
    } else if (action === GuestsAction.editGuest) {
      this.onEditGuestSave();
    }
    else if (action === GuestsAction.deleteGuest) {
      this.onDeleteGuestSave();
    }
    this._selectedAction = GuestsAction.None;
  }
  //===================
  onChangeStartHour(event) {
    console.debug("StartHour %s", event);
  }

  onChangeEndHour(event) {
    console.debug("EndHour %s", event);
  }
  //-------------------------------------------------------------------------
}

//------------------
export enum GuestsAction {
  None = 0,
  addNewGuest = 1,
  editGuest = 2,
  deleteGuest = 3
}
//--------------------


export interface EditGuestModel {
  guest: Guest;
  isEdit: boolean;
  guestValidateIdentityNumber: boolean;
  AllowEditGuestEndDate: boolean;
  incrementEndDateByOneDay: boolean;
  isAtidim: boolean;
  parksForDestinedGuest: ParkForReservedSubscriber[];
}


